module.exports = __webpack_public_path__ + "img/game_main_pc_280_off.687b3df0.png";